import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import useAxios from '../hooks/useAxios';
import { Currency } from 'common/contracts';
import { EQueryKeys } from '../constants/enums';
import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export function useCurrencies() {
  const axios = useAxios();

  const getCurrencies = useQuery<Currency[]>({
    retry: false,
    queryKey: [EQueryKeys.CURRENCIES],
    queryFn: async () => {
      const response = await axios.get(
        `${getApiRouteOrMock(EApiRoutes.CURRENCIES)}`
      );

      return response;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  const currencyCodeToCurrencyMap = useMemo(() => {
    return new Map<string, Currency>(
      getCurrencies.data?.map((currency) => [currency.currencyCode, currency])
    );
  }, [getCurrencies.data]);

  return {
    getCurrencies,
    currencyCodeToCurrencyMap
  };
}
